/**
 * Значение-недосписание в отчётах (Нераспределено > 0).
 *
 * Ревью дизайна тёмной темы (21.07): голый красный текст на тёмной строке
 * «кричит» как алерт. Даём мягкий красный (из STATUS-токена rejected) + лёгкую
 * фоновую плашку — предупреждение, а не тревога. Светлая тема — прежний вид.
 */
import { useMantineColorScheme } from "@mantine/core";

import { STATUS } from "../theme/tokens";

interface Props {
  /** Отформатированное значение (например, "40.00"). */
  value: string;
  /** true → недосписание (красная плашка); false → обычный текст. */
  danger: boolean;
  /** Жирное (для строки «Итого»). */
  bold?: boolean;
}

export function UnderbookedValue({ value, danger, bold }: Props) {
  const { colorScheme } = useMantineColorScheme();
  const tok = STATUS[colorScheme === "dark" ? "dark" : "light"].rejected;

  if (!danger) {
    return <span style={{ fontWeight: bold ? 700 : undefined }}>{value}</span>;
  }
  return (
    <span
      style={{
        color: tok.fg,
        background: tok.bg,
        border: `1px solid ${tok.border}`,
        borderRadius: 5,
        padding: "1px 7px",
        fontWeight: bold ? 700 : 500,
        fontVariantNumeric: "tabular-nums",
        whiteSpace: "nowrap",
      }}
    >
      {value}
    </span>
  );
}
